import { Injectable } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { LzPurchaseNewComponent } from "../components/lz-purchase-new/lz-purchase-new.component";
import { LzCookieService } from '../../../services/lz-cookie/lz-cookie';

@Injectable()
export class LzPurchaseService {

  private LzPurchaseDialogOptions: any = {
    autoFocus: false,
    panelClass: 'myPane'
  };

  constructor(public dialog: MatDialog, private cookie: LzCookieService) {

  }

  doPurchaseNew(alias ? : any, isReg ? : any, disableSlider ? : boolean): void {
    this.LzPurchaseDialogOptions.data = {
      'orderCode': alias,
      'isTrial': isReg,
      'disableSlider': disableSlider
    };
    this.dialog.open(LzPurchaseNewComponent, this.LzPurchaseDialogOptions);
  }

}
